module.exports = __webpack_public_path__ + "img/good-bye.1eb6b548.png";